var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "form",
          {
            attrs: {
              autocomplete: "off",
              method: "post",
              "data-vv-scope": "form",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return (() => {}).apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-sm-auto" }, [
                _c("h1", { staticClass: "content-title" }, [
                  _vm._v(_vm._s(_vm.titleItem)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "h6",
                  {
                    staticClass: "pt-3 font-weight-normal w-100 cursor-pointer",
                    attrs: {
                      href: "#contact",
                      "data-toggle": "collapse",
                      "aria-expanded": "false",
                      "aria-controls": "#contact",
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t(`${_vm.pageID}.contact.divider`)) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("hr", { staticClass: "mt-2" }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row collapse", attrs: { id: "contact" } },
              [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t(`${_vm.pageID}.contact.address`))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "city-form-group",
                        class: {
                          "is-invalid": _vm.fnHasError("contact_address"),
                        },
                      },
                      [
                        _c("ckeditor", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "min:3",
                              expression: "'min:3'",
                            },
                          ],
                          attrs: {
                            name: "contact_address",
                            disabled: _vm.readonlyFormItem,
                            editor: _vm.cKEditor.editor,
                            config: _vm.cKEditor.editorConfig,
                          },
                          model: {
                            value: _vm.form.contact.address,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.contact, "address", $$v)
                            },
                            expression: "form.contact.address",
                          },
                        }),
                        _vm._v(" "),
                        _vm.fnFirstError("contact_address")
                          ? _c(
                              "small",
                              { staticClass: "d-block invalid-feedback" },
                              [
                                _vm._v(
                                  _vm._s(_vm.fnFirstError("contact_address"))
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-sm-6" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "min:9",
                            expression: "'min:9'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          autocomplete: "new-phone",
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          type: "text",
                          id: "input-contact_phone",
                          name: "contact_phone",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("contact_phone") },
                          ],
                          error: _vm.fnFirstError("contact_phone"),
                        },
                        model: {
                          value: _vm.form.contact.phone,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.contact,
                              "phone",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.contact.phone",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.pageID}.contact.phone`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-sm-6" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "email",
                            expression: "'email'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          autocomplete: "new-email",
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          type: "email",
                          id: "input-contact_email",
                          name: "contact_email",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("contact_email") },
                          ],
                          error: _vm.fnFirstError("contact_email"),
                        },
                        model: {
                          value: _vm.form.contact.email,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.contact,
                              "email",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.contact.email",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.pageID}.contact.email`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-sm-4" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "latLng",
                            expression: "'latLng'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          type: "text",
                          id: "input-contact_coordinates",
                          name: "contact_coordinates",
                          placeholder: _vm.$t(
                            `${_vm.pageID}.contact.coordinates_placeholder`
                          ),
                          inputClasses: [
                            {
                              "is-invalid": _vm.fnHasError(
                                "contact_coordinates"
                              ),
                            },
                          ],
                          error: _vm.fnFirstError("contact_coordinates"),
                        },
                        model: {
                          value: _vm.form.contact.coordinates,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.contact,
                              "coordinates",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.contact.coordinates",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(`${_vm.pageID}.contact.coordinates`)
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-sm-8" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { url: { require_protocol: true } },
                            expression: "{url: {require_protocol: true }}",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          type: "text",
                          id: "input-contact_coordinates_link",
                          name: "contact_coordinates_link",
                          inputClasses: [
                            {
                              "is-invalid": _vm.fnHasError(
                                "contact_coordinates_link"
                              ),
                            },
                          ],
                          error: _vm.fnFirstError("contact_coordinates_link"),
                        },
                        model: {
                          value: _vm.form.contact.coordinates_link,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.contact,
                              "coordinates_link",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.contact.coordinates_link",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(`${_vm.pageID}.contact.coordinates_link`)
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "h6",
                  {
                    staticClass: "pt-3 font-weight-normal w-100 cursor-pointer",
                    attrs: {
                      href: "#google",
                      "data-toggle": "collapse",
                      "aria-expanded": "false",
                      "aria-controls": "#google",
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t(`${_vm.pageID}.google.divider`)) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("hr", { staticClass: "mt-2" }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row collapse", attrs: { id: "google" } },
              [
                _c(
                  "div",
                  { staticClass: "col-sm-6" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { min: 3 },
                            expression: "{'min':3}",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          id: "input-google_g_maps_api",
                          name: "google_g_maps_api",
                          inputClasses: [
                            {
                              "is-invalid": _vm.fnHasError("google_g_maps_api"),
                            },
                          ],
                          error: _vm.fnFirstError("google_g_maps_api"),
                          helpTruncate: false,
                          helpText: `${_vm.pageID}.google.help.g_maps_api`,
                        },
                        model: {
                          value: _vm.form.google.g_maps_api.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.google.g_maps_api,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.google.g_maps_api.key",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.pageID}.google.g_maps_api`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-sm-6" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { min: 3 },
                            expression: "{'min':3}",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          id: "input-google_g_analytics_api",
                          name: "google_g_analytics_api",
                          inputClasses: [
                            {
                              "is-invalid": _vm.fnHasError(
                                "google_g_analytics_api"
                              ),
                            },
                          ],
                          error: _vm.fnFirstError("google_g_analytics_api"),
                          helpTruncate: false,
                          helpText: `${_vm.pageID}.google.help.g_analytics_api`,
                        },
                        model: {
                          value: _vm.form.google.g_analytics_api.id,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.google.g_analytics_api,
                              "id",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.google.g_analytics_api.id",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(`${_vm.pageID}.google.g_analytics_api`)
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "h6",
                  {
                    staticClass: "pt-3 font-weight-normal w-100 cursor-pointer",
                    attrs: {
                      href: "#social-networks",
                      "data-toggle": "collapse",
                      "aria-expanded": "false",
                      "aria-controls": "#social-networks",
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$t(`${_vm.pageID}.social_networks.divider`)
                        ) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("hr", { staticClass: "mt-2" }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row collapse", attrs: { id: "social-networks" } },
              [
                _c("div", { staticClass: "col-sm-12" }, [
                  _c("div", { staticClass: "city-form-group" }, [
                    _c(
                      "table",
                      { staticClass: "table table-sm table-responsive-sm" },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticClass: "text-center font-regular",
                                attrs: { scope: "col" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(`${_vm.pageID}.social_networks.id`)
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "text-center font-regular",
                                attrs: { scope: "col" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(`${_vm.pageID}.social_networks.url`)
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.readonlyFormItem
                              ? _c(
                                  "th",
                                  {
                                    staticClass:
                                      "text-center actions d-print-none",
                                    attrs: { scope: "col" },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-main btn-sm min-w-auto m-0",
                                        attrs: { type: "button" },
                                        on: { click: _vm.addValueItem },
                                      },
                                      [_c("i", { staticClass: "fas fa-plus" })]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(
                            _vm.form.social_networks,
                            function (item, index) {
                              return _c("tr", { key: index }, [
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "MaterialSelect",
                                      {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'",
                                          },
                                        ],
                                        staticClass:
                                          "city-form-group city-bg city-bg-sm",
                                        attrs: {
                                          readonly: _vm.readonlyFormItem,
                                          id: `input-social_id_${index}`,
                                          name: `social_id_${index}`,
                                          label: "name",
                                          options: _vm.socialNetworks,
                                          reduce: (option) => option.id,
                                          inputClasses: [
                                            {
                                              "is-invalid": _vm.fnHasError(
                                                `social_id_${index}`
                                              ),
                                            },
                                          ],
                                          error: _vm.fnFirstError(
                                            `social_id_${index}`
                                          ),
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selected-option",
                                              fn: function ({ option, label }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-row flex-nowrap align-items-center",
                                                    },
                                                    [
                                                      _c("i", {
                                                        class: [
                                                          "pr-2",
                                                          option["icon"],
                                                        ],
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            option[label]
                                                          ) +
                                                          "\n                                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "option",
                                              fn: function ({ option, label }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-row flex-nowrap align-items-center",
                                                    },
                                                    [
                                                      _c("i", {
                                                        class: [
                                                          "pr-2",
                                                          option["icon"],
                                                        ],
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            option[label]
                                                          ) +
                                                          "\n                                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: item.id,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "id",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "item.id",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                " +
                                            _vm._s(
                                              _vm.$t(
                                                `${_vm.pageID}.social_networks.id`
                                              )
                                            ) +
                                            "\n\n                                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "MaterialInput",
                                      {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required: true,
                                              url: { require_protocol: true },
                                            },
                                            expression:
                                              "{required: true, url: {require_protocol: true}}",
                                          },
                                        ],
                                        staticClass:
                                          "city-form-group city-bg city-bg-sm",
                                        attrs: {
                                          readonly: _vm.readonlyFormItem,
                                          id: `input-social_url_${index}`,
                                          name: `social_url_${index}`,
                                          inputClasses: [
                                            {
                                              "is-invalid": _vm.fnHasError(
                                                `social_url_${index}`
                                              ),
                                            },
                                          ],
                                          error: _vm.fnFirstError(
                                            `social_url_${index}`
                                          ),
                                        },
                                        model: {
                                          value: item.url,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "url",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "item.url",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                " +
                                            _vm._s(
                                              _vm.$t(
                                                `${_vm.pageID}.social_networks.url`
                                              )
                                            ) +
                                            "\n                                            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.readonlyFormItem
                                  ? _c(
                                      "td",
                                      {
                                        staticClass: "text-center d-print-none",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-danger btn-sm min-w-auto",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeValueItem(
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-trash",
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.social_networks,
                          expression: "form.social_networks",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''",
                        },
                      ],
                      attrs: { type: "hidden", name: "social_networks" },
                      domProps: { value: _vm.form.social_networks },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form,
                            "social_networks",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("buttons-footer", {
              attrs: {
                enableButtons: !_vm.readonlyFormItem,
                cancelTitle: _vm.cancelTitle,
                submitTitle: _vm.submitTitle,
                isDisabled: _vm.isDisabled,
              },
              on: {
                save: _vm.beforeSaveItem,
                cancel: function ($event) {
                  return _vm.handleBack(`${_vm.moduleCode}.${_vm.pageID}`)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }